<template>
  <van-popup v-model="showPage" position="bottom" :close-on-click-overlay="false" @closed="onClosed" @click-overlay="onClose">
    <van-row class="topBar">
      <van-col span="4"><i class="iconfont iconback" @click="onClose" /></van-col>
      <van-col span="16" class="center">{{ title }}</van-col>
      <van-col span="4" class="rigth" :style="'color:'+GetDiveMainBack()" @click="onSubject">提交</van-col>
    </van-row>
    <div class="inputRect">
      <van-row v-for="(config,index) in configList" :key="index" class="rateBar">
        <van-col span="6" class="title"><span>{{ config.name }}</span></van-col>
        <van-col span="18">
          <van-rate v-model="postData[index].score" :disabled="commentType==='Coach' || commentType==='Course'" class="rate" :color="GetDiveMainBack()" void-icon="star" void-color="#eee" />
          <div class="starAbout">
            <span>{{ getScoreText(postData[index].score) }}</span>
          </div>
        </van-col>
      </van-row>
    </div>
    <div v-if="commentType==='Coach' || commentType==='Course'" class="inputRect notScoreBody">
      只有参加该教练课程/行程才可以评分!
    </div>
    <div v-if="commentType!=='Coach'&& commentType!=='Course'" class="TagRect">
      <div class="title"><i class="iconfont iconquanzi" /> 请选择一下标签或填写意见，感谢您的意见反馈!</div>
      <template v-for="(config,index) in configList">
        <template v-for="tag in config.tagNices">
          <van-button
            v-if="config.tagNiceType==='NORMAL' || (config.tagNiceType==='AUTO' && postData[index].score >4)"
            :key="tag"
            class="tagButton"
            round
            size="mini"
            :color="GetDiveMainBack()"
            :plain="!checkInTag(index,tag)"
            @click="addTag(index,tag)"
          >
            {{ tag }}
          </van-button>
        </template>
      </template>

      <template v-for="(config,index) in configList">
        <template v-for="tag in config.tagBadlys">
          <van-button
            v-if="config.tagBadlyType==='NORMAL' || (config.tagBadlyType==='AUTO' && postData[index].score <=4)"
            :key="tag"
            class="tagButton"
            round
            size="mini"
            :color="GetDiveMainBack()"
            :plain="!checkInTag(index,tag)"
            @click="addTag(index,tag)"
          >
            {{ tag }}
          </van-button>
        </template>
      </template>
    </div>
    <div class="RichRect">
      <div class="title"><i class="iconfont iconcomment" /> 完成优质评论,将有机会获得积分奖励哦~</div>
      <van-field
        v-model="remark"
        class="fieldRect"
        style="padding:0 1em;background-color:transparent;"
        rows="3"
        :autosize="{maxHeight:200}"
        type="textarea"
        maxlength="1024"
        placeholder="感觉怎么样?跟大家分享一下吧"
        show-word-limit
      />
      <div class="imageUploadRect" :style="fileList.length>0?'text-align:left':'text-align:center'">
        <van-uploader
          v-model="fileList"
          class="imageUpload"
          multiple
          :max-count="5"
          :after-read="afterRead"
        />
      </div>
      <div class="anonymous">
        <van-checkbox v-model="isAnonymous" :checked-color="GetDiveMainBack()">匿名评论</van-checkbox>
      </div>
    </div>
  </van-popup>
</template>
<script>
import request from '@/utils/request'
import { getDiveCommentConfigList } from '@/utils/baseData'
import { Button, Popup, Field, Rate, Uploader, Checkbox, Dialog } from 'vant'
import { compressorImageList, MyNotify, getScoreText, GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
// import { formatDate } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Rate.name]: Rate,
    [Uploader.name]: Uploader,
    [Checkbox.name]: Checkbox,
    [Dialog.name]: Dialog
  },
  props: {
    value: Boolean,
    // eslint-disable-next-line
    title: {
      default: '发表评论'
    },
    // eslint-disable-next-line
    commentType:undefined,
    // eslint-disable-next-line
    commentId:undefined,
  },
  data() {
    return {
      showPage: false,
      remark: '',
      fileList: [],
      buttonLoading: false,
      isAnonymous: false,
      editAnyValue: true,
      configList: [],
      tagList: [
        { title: '没见到', select: false },
        { title: '不可爱', select: false },
        { title: '好可怕', select: false },
        { title: '不详细', select: false },
        { title: '有错误', select: false },
        { title: '太可怕了', select: false },
        { title: '潜导没带我看', select: false },
        { title: '潜导没找到', select: false },
        { title: '潜导找到了没告诉我', select: false },
        { title: '潜导坑我', select: false }
      ],
      postData: [
        { score: 5, tag: [] },
        { score: 5, tag: [] },
        { score: 5, tag: [] },
        { score: 5, tag: [] },
        { score: 5, tag: [] },
        { score: 5, tag: [] },
        { score: 5, tag: [] },
        { score: 5, tag: [] },
        { score: 5, tag: [] },
        { score: 5, tag: [] }
      ]

    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.showPage = true
        getDiveCommentConfigList((data) => {
          this.configList = data.filter(item => item.type === this.commentType)
          console.log(' this.configList', this.configList)
        })
      }
    }

  },
  created() {
  },
  methods: {
    getScoreText,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetColorMainLine,
    onClose() {
      console.log('onClose')
      if (!this.editAnyValue) {
        this.showPage = false
        return
      }
      Dialog.confirm({
        title: '您尚未发布',
        message: '是否要退出',
        confirmButtonText: '继续编辑',
        confirmButtonColor: GetDiveMainBack(),
        cancelButtonText: '退出'
      })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          this.showPage = false
        })
    },
    onClosed() {
      console.log('onClosed')
      this.$emit('input', false)
    },
    uploadImg(files, callback) {
      var noFile = true
      var fileList = []
      files.map((value, index, array) => {
        if (value.file) {
          fileList.push(value.file)
          noFile = false
        }
      })
      if (noFile) {
        if (callback) {
          callback('')
        }
        return
      }
      compressorImageList(fileList, 1024, 1024, 0.6, (list) => {
        const formData = new FormData()
        list.map((value, index, array) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        request({
          url: '/Data/uploadFile?config=divecomment',
          method: 'post',
          data: formData
        }).then(response => {
          console.log('上传图片反馈', response)
          if (!response.success) {
            this.buttonLoading = false
            return
          }
          var list = []
          response.data.map((value, index, array) => {
            list.push(value.save)
          })
          if (callback) {
            callback(list.toString())
          }
        })
      })
    },
    afterRead() {

    },
    checkInTag(index, tag) {
      var result = this.postData[index].tag.filter(item => item === tag).length > 0
      return result
    },
    addTag(index, tag) {
      var list = this.postData[index].tag
      var have = this.checkInTag(index, tag)
      if (have) {
        this.postData[index].tag = list.filter(item => item !== tag)
      } else {
        this.postData[index].tag.push(tag)
      }
      console.log('addTag', this.postData[index].tag)
    },
    onSubject() {
      this.buttonLoading = true

      this.uploadImg(this.fileList, (urls) => {
        var postData = [{
          type: this.commentType,
          id: this.commentId,
          about: this.remark,
          res: urls,
          isAnonymous: this.isAnonymous,
          score: 5,
          scoreList: []
        }]
        var i = 0
        var score = 0
        this.configList.forEach(config => {
          score += this.postData[i].score
          postData[0].scoreList.push({
            tag: this.postData[i].tag.join(','),
            score: this.postData[i].score,
            location: config.location
          })
          i++
        })
        postData[0].score = parseInt(score / i + 0.5)
        request({
          url: '/DiveData/AddDiveCommnet',
          method: 'post',
          data: postData
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          MyNotify('success', '提交成功')
          this.showPage = false
        })
      })
    }
  }
}
</script>

<style scoped>
.topBar{
    padding:0.8em 1em;
    border-bottom: 1px solid #f5f5f5;
}
.topBar i{
    font-size: 0.9em;
    color: #999;
}
.inputRect{
    padding: 0.5em 1em;
}
.inputRect .lineTitle{
    font-size: 0.9em;
    padding-bottom:0.25em;
}
.inputRect .rateBar{
    padding: 0.25em 0;
}
.inputRect .rateBar .title span{
    font-size: 0.8em;
}
.inputRect .rateBar .rate
{
    float: left;
}
.inputRect .rateBar .starAbout{
  float: left;
  margin-left: 0.5em;
}
.inputRect .rateBar .starAbout span{
    font-size: 0.8em;
    color: #999;
}

.RichRect{
    background-color: #f5f5f5;
    border-top-left-radius: 1em;
    border-top-right-radius: 1em;
}
.RichRect .title{
    font-size: 0.6em;
    padding: 0.5em 1em;
    border-bottom: 1px solid #fafafa;
}
.RichRect .imageUploadRect{
  padding:0.5em 0.5em 0 0.5em;
  margin:0.25em 1em;
  background-color: #fff;
  box-shadow: 2px 2px 8px rgba(0,0,0,0.1);
}
.RichRect .anonymous{
    padding: 0.5em 1em;
}

.TagRect{
    padding: 0.5em 1em;
}
.TagRect .title{
    font-size: 0.6em;
    padding: 0.5em 0;
    border-bottom: 1px solid #fafafa;
}
.TagRect  .tagButton{
    margin:0 0.5em 0.5em 0;
    padding-left: 1em;
    padding-right: 1em;
}
.notScoreBody{
  padding: 0 1em;
  color: #999;
  font-size: 0.8em;
  padding-bottom: 1.5em;
}
</style>
